import {useEffect, useState, useCallback} from "react";
import {t} from "i18next";
import {Card, Select} from "antd";
import ApiService from "../../core/service/api-service";

export default function MetabaseDashboard() {
    const [dashboards, setDashboards] = useState([])
    const [id, setId] = useState(null)
    const [link, setLink] = useState('')

    const loadDashboards = useCallback(async () => {
        const res = await ApiService.User.GetUserDashboards()
        if(res.success) {
            setDashboards(res.data)
            if(res.data.length > 0) {
                setId(res.data[0].id)
            }
        }
    }, [])

    const createLink = useCallback(async () => {
        if(!id) return
        const res = await ApiService.User.GetDashboardLink(id)
        if(res.success) {
            setLink(res.data)
        }
    }, [id])

    useEffect(() => {
        loadDashboards()
    }, [loadDashboards]);

    useEffect(() => {
        createLink()
    }, [createLink])

    if(dashboards.length === 0) {
        return (
            <Card>
                <div style={{textAlign: 'center', padding: 40, color: '#999'}}>
                    {t('No dashboards assigned')}
                </div>
            </Card>
        )
    }

    return (
        <Card>
            <Select
                size={'small'}
                style={{width: 400, marginBottom: 16}}
                placeholder={t('Dashboard')}
                value={id}
                onChange={(e) => setId(e)}
            >
                {
                    dashboards.map(dashboard => (
                        <Select.Option key={dashboard.id} value={dashboard.id}>
                            {dashboard.name}
                        </Select.Option>
                    ))
                }
            </Select>
            <iframe
                title="Metabase Dashboard"
                src={link}
                frameBorder={0}
                width={'100%'}
                height={window.innerHeight - 200}
                allowTransparency
            />
        </Card>
    )
}
